// extracted by mini-css-extract-plugin
module.exports = {"beaucoupDeResultats":"BeaucoupDeResultats_beaucoupDeResultats__3U4Yr","controls":"BeaucoupDeResultats_controls__2_-oD","btn":"BeaucoupDeResultats_btn__2sMqd"};